import { UPDATE_DP_FOOTNOTE_CONFIG_DATA } from "src/DigitalProtocolModule/constants";

export const initialFootnoteConfig = {
  footnoteTypeList: [],
  footnoteOptionList: [],
  activityOptionList: [],
};

const dpFootnoteConfigReducer = (state = initialFootnoteConfig, action) => {
  switch (action.type) {
    case UPDATE_DP_FOOTNOTE_CONFIG_DATA:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    default:
  }
  return state;
};
export default dpFootnoteConfigReducer;
